// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"Sitemap_sitemap__2e7am","orderedList":"Sitemap_orderedList__24hEy","links":"Sitemap_links__2Snzw"};